import React from "react";
import { Switch } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { ToastContainer } from "react-toastify";

import ProtectedRoute from "./components/ProtectedRoute";
import NavigationBar from "./components/NavigationBar";
import Loading from "./components/Loading";
import Home from "./pages/Home";
import CreateForm from "./pages/CreateForm";
import ViewForm from "./pages/ViewForm";

import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <ToastContainer />
      <NavigationBar />

      <div className="container mt-5">
        <Switch>
          <ProtectedRoute path="/" exact component={Home} />
          <ProtectedRoute path="/createForm" component={CreateForm} />
          <ProtectedRoute path="/viewForm" component={ViewForm} />
        </Switch>
      </div>
    </div>
  );
};

export default App;
